import React from 'react';

import InsertPopoverOptions from "./insert-popover-options";
import PopupMenuButton from "src/core/gd-components/popover-menu/popup-menu-button/popup-menu-button";

export default function InsertOptions(props) {

    const button = () =>
        <React.Fragment>
            <div className="ico ui5-ico-14 ii5-actions"/>
            <div className="btn-label">Insert...</div>
        </React.Fragment>

    return (
        // <PopupMenuButton className="gd-draftail-toolbar-button insert-menu"
        <PopupMenuButton className="ui5-control-button-with-label s-26"
                         hint="Insert options"
                         btnComponent={button}
                         menuComponent={InsertPopoverOptions}
                         menuParams={{
                             onRequestSource:   props.onRequestSource,
                             addHorizontalLine: props.addHorizontalLine,
                             addBR:             props.addBR,
                             addMention:        props.addMention,
                             addLinkTask:       props.addLinkTask,
                             addLinkNote:       props.addLinkNote,
                         }}/>
    )
}
